import styled from 'styled-components';
import { Text16Bold } from '../../../components/utils/Text/Text.styles';
import { Button } from '../../../components/utils/Button/Button';

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 76rem;
  padding: 2.4rem 0;

  @media only screen and (max-width: 760px) {
    height: 100%;
    padding: 1.6rem 1.2rem;
  }

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 3rem;
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  width: 42rem;
  margin-inline: auto;

  @media only screen and (max-width: 500px) {
    width: 100%;
  }
`;

export const QuestionnaireSection = styled.div`
  width: 100%;
`;

export const SectionTitle = styled(Text16Bold)`
  margin-bottom: 1.6rem;
`;

export const TitleContainer = styled.div`
  position: relative;
`;

export const StyledButton = styled(Button)`
  margin-top: 3.2rem;
  width: 24rem;

  @media only screen and (max-width: 500px) {
    margin-top: auto;
    width: 100%;
  }
`;

export const MoreQuestionsButton = styled(Button)`
  background: #d8eaf9;
  color: #1672ba;
  border: none;
  font-size: 1.4rem;
  font-weight: 400;
  margin-bottom: 1.6rem;
`;
